import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { 
  MessageCircle, 
  Star,
  RefreshCw,
  ExternalLink,
  ThumbsUp
} from 'lucide-react';
import { toast } from 'sonner';

const AdminReviewsPage = () => {
  const [reviews, setReviews] = useState([
    { id: '1', author: 'Pierre D.', rating: 5, text: 'Excellent travail, très professionnel !', date: '2025-01-12', visible: true },
    { id: '2', author: 'Sophie M.', rating: 5, text: 'Agence réactive et compétente.', date: '2025-01-08', visible: true },
    { id: '3', author: 'Marc L.', rating: 4, text: 'Bon service, je recommande.', date: '2025-01-05', visible: true },
  ]);
  const [syncing, setSyncing] = useState(false);

  const handleSync = async () => {
    setSyncing(true);
    setTimeout(() => {
      setSyncing(false);
      toast.success('Avis synchronisés avec Google');
    }, 2000);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">Avis Google</h1>
          <p className="text-[#64748b]">Synchronisez et affichez vos avis clients</p>
        </div>
        <Button onClick={handleSync} disabled={syncing} className="bg-amber-600 hover:bg-amber-700">
          <RefreshCw className={`w-4 h-4 mr-2 ${syncing ? 'animate-spin' : ''}`} />
          {syncing ? 'Synchronisation...' : 'Synchroniser'}
        </Button>
      </div>

      {/* Stats */}
      <div className="grid md:grid-cols-3 gap-4">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-yellow-100 flex items-center justify-center">
                <Star className="w-5 h-5 text-yellow-600 fill-yellow-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-[#1a365d]">4.9</p>
                <p className="text-sm text-[#64748b]">Note moyenne</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-[#1a365d]">{reviews.length}</p>
                <p className="text-sm text-[#64748b]">Avis total</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                <ThumbsUp className="w-5 h-5 text-emerald-600" />
              </div>
              <div>
                <p className="text-2xl font-bold text-[#1a365d]">100%</p>
                <p className="text-sm text-[#64748b]">Avis positifs</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Reviews List */}
      <Card>
        <CardHeader>
          <CardTitle>Derniers avis</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {reviews.map((review) => (
              <div key={review.id} className="p-4 rounded-lg border">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <p className="font-semibold text-[#1a365d]">{review.author}</p>
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <Star 
                            key={i} 
                            className={`w-4 h-4 ${i < review.rating ? 'text-yellow-500 fill-yellow-500' : 'text-slate-300'}`} 
                          />
                        ))}
                      </div>
                    </div>
                    <p className="text-[#64748b]">{review.text}</p>
                    <p className="text-xs text-[#94a3b8] mt-2">{new Date(review.date).toLocaleDateString('fr-FR')}</p>
                  </div>
                  <Badge variant={review.visible ? 'default' : 'secondary'}>
                    {review.visible ? 'Visible' : 'Masqué'}
                  </Badge>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminReviewsPage;
